import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeWebVitals } from "@/lib/performance/webVitals";

createRoot(document.getElementById("root")!).render(<App />);

initializeWebVitals();
